import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ManageModal from '../modals/ManageModal';
import CheckBox from '../CheckBox';

const defaultSizes = [35, 36, 37, 38, 39, 40];

const SizeAlertModal = ({ product, onClose, onSuccess }) => {
  const { t } = useTranslation();
  const [sizes, setSizes] = useState([35]);

  const onFormChange = item => {
    const tempSizes = [...sizes];
    if (tempSizes.includes(item)) {
      tempSizes.splice(tempSizes.indexOf(item), 1);
    } else {
      tempSizes.push(item);
    }
    setSizes(tempSizes);
  };

  const onFormSubmit = () => {
    onSuccess();
  };

  const isButtonDisabled = !sizes.length;

  return (
    <ManageModal
      isNewProjectCreation
      title={t('size_alarm_modal_title')}
      sumbitButton={t('btn_create_alert')}
      onCloseModal={onClose}
      onSubmit={onFormSubmit}
      className='large-modal alert-modal'
      isButtonDisabled={isButtonDisabled}
    >
      <div className='row pb-5'>
        <div className='col-12 col-md-6'>
          <img
            className='product-image mb-md-10 mb-5'
            width='100%'
            src={product.images && product.images[0]}
            alt='product'
          />
          <p className='mb-0 text-dark fw-500'>{t('text_current_size')} M</p>
        </div>
        <div className='col-12 col-md-6 mt-5 mt-md-0'>
          <p className='text-lg text-dark fw-500 mb-5 mb-md-8'>{t('alert_slelect_size_label')}</p>
          <div className='row col-12'>
            {defaultSizes.map(item => {
              return (
                <CheckBox
                  key={item}
                  className='mb-md-8 mb-7 col-6 col-md-12'
                  label={item}
                  id={`check${item}`}
                  name={`check${item}`}
                  checked={sizes.includes(item)}
                  onChange={onFormChange.bind(null, item)}
                />
              );
            })}
          </div>
        </div>
      </div>
    </ManageModal>
  );
};

export default SizeAlertModal;
